import React from 'react';
import Link from 'next/link';
import { EMAIL } from '@/constants';
import { useSelector } from 'react-redux';
import ErrorMessage from './ErrorMessage';
import TextSmall from '../Typography/TextSmall';

function LoginFormFooter({ activeTab }) {
  const { isAccessDenied } = useSelector((state) => state.auth);

  const onClickLink = (e, url) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');

    // do something
  };

  return (
    <>
      <TextSmall className="text-sm lg:text-xs text-center text-standstone font-medium">
        By tapping send OTP, you agree to &nbsp;
        <Link
          prefetch={false}
          aria-label="Go to terms and conditions"
          href="/terms-conditions"
          // target="_blank"
          // rel="noopener noreferrer"
          onClick={(e) => onClickLink(e, '/terms-conditions')}
          className="text-sm lg:text-xs text-gunmetal !font-semibold no-underline"
        >
          Terms and Conditions
        </Link>
        &nbsp; and &nbsp;
        <Link
          prefetch={false}
          aria-label="Go to privacy policy"
          href="/privacy-policy"
          onClick={(e) => onClickLink(e, '/privacy-policy')}
          className="text-sm lg:text-xs text-gunmetal !font-semibold no-underline"
        >
          Privacy Policy
        </Link>
        &nbsp; of Singer Bangladesh
      </TextSmall>
      {isAccessDenied ? (
        <ErrorMessage
          textPrimary="Too many OTP verification attempts."
          textSecondary={`Login with this ${activeTab === 'phone' ? 'number' : EMAIL} is locked for few minutes.`}
          type="accessDeniedError"
        />
      ) : null}
    </>
  );
}

export default LoginFormFooter;
